import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = sessionStorage.getItem('countdown_end');
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      return remaining;
    }
    // 2 hours countdown
    const end = Date.now() + 2 * 60 * 60 * 1000;
    sessionStorage.setItem('countdown_end', end.toString());
    return 2 * 60 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="mt-8 pt-8 border-t border-bordo/20" data-id="element-69">
      <p className="text-bordo font-bold text-lg mb-4 uppercase tracking-wide" data-id="element-70">
        ⚡ Esta oferta expira en:
      </p>
      <div className="flex items-center justify-center gap-3" data-id="element-71">
        <div className="bg-bordo text-crema rounded-xl px-4 py-3 min-w-[70px] shadow-lg" data-id="element-72">
          <span className="text-3xl md:text-4xl font-bold font-mono" data-id="element-73">
            {pad(hours)}
          </span>
          <p className="text-xs uppercase tracking-wider mt-1 opacity-80" data-id="element-74">
            Horas
          </p>
        </div>
        <span className="text-bordo text-3xl font-bold" data-id="element-75">:</span>
        <div className="bg-bordo text-crema rounded-xl px-4 py-3 min-w-[70px] shadow-lg" data-id="element-76">
          <span className="text-3xl md:text-4xl font-bold font-mono" data-id="element-77">
            {pad(minutes)}
          </span>
          <p className="text-xs uppercase tracking-wider mt-1 opacity-80" data-id="element-78">
            Min
          </p>
        </div>
        <span className="text-bordo text-3xl font-bold" data-id="element-79">:</span>
        <div className="bg-bordo text-crema rounded-xl px-4 py-3 min-w-[70px] shadow-lg" data-id="element-80">
          <span className="text-3xl md:text-4xl font-bold font-mono" data-id="element-81">
            {pad(seconds)}
          </span>
          <p className="text-xs uppercase tracking-wider mt-1 opacity-80" data-id="element-82">
            Seg
          </p>
        </div>
      </div>
      <p className="text-sm text-gray-500 mt-3" data-id="element-83">
        Después de este tiempo, el precio vuelve a $49.990
      </p>
    </motion.div>;
}